import * as t from 'io-ts';

export const countryCodec = t.type({
  code: t.string,
  name: t.string,
});

export const countryListCodec = t.type({
  data: t.array(countryCodec),
});
